module.exports = __webpack_public_path__ + "img/basemap_satellite.e4b0ee19.png";